import { Link } from "react-router-dom";
import { clinicInfo } from "@/config/site";
import logo from '../../assets/logo_final.png';

const links = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "Blogs", to: "/blogs" },
  { label: "Published Papers", to: "/published-papers" },
  { label: "Contact", to: "/contact" },
  { label: "Admin", to: "/admin/login" },
];

export default function SiteFooter() {
  return (
    <footer
      className="mt-20 border-t border-[#f2e6c9] bg-[#fffdf8]"
      data-testid="global-footer"
    >
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-12 md:grid-cols-3 md:px-10">
        <div>
          <p
            className="font-[Playfair_Display] text-2xl text-[#1a1a1a]"
            data-testid="footer-clinic-name"
          >
            <img src={logo} className="h-12 w-28"/>
          </p>
          <p
            className="mt-2 max-w-sm font-[Manrope] text-sm text-[#575757]"
            data-testid="footer-tagline"
          >
            Premium implant and microscopic dentistry with high sterilization,
            compassionate care, and advanced technology in Hubballi.
          </p>
        </div>

        <div>
          <h3
            className="font-[Manrope] text-xs font-bold uppercase tracking-[0.2em] text-[#8b7a55]"
            data-testid="footer-quick-links-title"
          >
            Quick Links
          </h3>
          <div className="mt-4 grid grid-cols-2 gap-2">
            {links.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="font-[Manrope] text-sm text-[#333333] transition-colors hover:text-[#b08d45]"
                data-testid={`footer-link-${item.label
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h3
            className="font-[Manrope] text-xs font-bold uppercase tracking-[0.2em] text-[#8b7a55]"
            data-testid="footer-contact-title"
          >
            Contact
          </h3>
          <p
            className="mt-4 font-[Manrope] text-sm text-[#444444]"
            data-testid="footer-phone"
          >
            Phone: {clinicInfo.phone}
          </p>
          <p
            className="mt-2 font-[Manrope] text-sm text-[#444444]"
            data-testid="footer-address"
          >
            {clinicInfo.address}
          </p>
          <p
            className="mt-2 font-[Manrope] text-sm text-[#444444]"
            data-testid="footer-hours"
          >
            Mon-Sat: 10:30 AM onwards
          </p>
        </div>
      </div>

      <div className="border-t border-[#f2e6c9] px-6 py-4 text-center font-[Manrope] text-xs text-[#7a7a7a] md:px-10">
        <p data-testid="footer-copyright-text">
          © {new Date().getFullYear()} Kavlekar Dental. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
